import { ref } from 'vue';

const isBannerOpen = ref(false);
const isPreferencesOpen = ref(false);

const preferences = ref({
  essential: true,
  analytics: true,
  marketing: true,
});

const isInitialized = ref(false);

export function useCookieConsent() {
  const init = () => {
    if (isInitialized.value) return;
    if (typeof window === 'undefined') return;

    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Check if we should show the banner
      // For now, always show if no consent
      isBannerOpen.value = true;
    } else {
      try {
        const parsed = JSON.parse(consent);
        if (typeof parsed === 'object') {
          preferences.value = { ...preferences.value, ...parsed, essential: true };
        }
      } catch {
        // ignore
      }
    }
    isInitialized.value = true;
  };

  const saveConsent = () => {
    if (typeof window === 'undefined') return;
    localStorage.setItem('cookie_consent', JSON.stringify(preferences.value));
    isBannerOpen.value = false;
  };

  const acceptAll = () => {
    preferences.value = {
      essential: true,
      analytics: true,
      marketing: true,
    };
    saveConsent();
  };

  const openPreferences = () => {
    isPreferencesOpen.value = true;
  };

  const savePreferences = () => {
    saveConsent();
    isPreferencesOpen.value = false;
  };

  return {
    isBannerOpen,
    isPreferencesOpen,
    preferences,
    init,
    acceptAll,
    openPreferences,
    savePreferences,
  };
}
